export class SearchField {
  static FIELD_TYPES = {
    FIELD_TEXT: 'text',
    FIELD_SELECT: 'select',
    FIELD_CHECK_BOX: 'checkbox',
  }

  isAdvanced = false
  label = null
  description = null
  type = SearchField.FIELD_TEXT
  values = []
  value = ''
  key = null

  setDescription(desc) {
    this.description = desc;
    return this;
  }

  setKey(key) {
    this.key = key
    return this;
  }

  setValues(values) {
    this.values = values;
    return this;
  }

  setType(type) {
    this.type = type
    return this;
  }

  setLabel(label) {
    this.label = label
    return this;
  }

  setIsAdvanced(isAdvanced) {
    this.isAdvanced = isAdvanced
    return this;
  }
}
